import React, { useState } from 'react';
import styled from '@emotion/styled';

import Copyright from './elements/Copyright';

import vw from 'styles/utils';
import media from 'styles/media';

function Footer() {
  const [isShowIEKTopicsOptions, setIsShowIEKTopicsOptions] = useState(false);

  const handleClickIEKTopics = () => {
    setIsShowIEKTopicsOptions(!isShowIEKTopicsOptions);
  }

  return (
    <Root>
      <Container>
        <Row>
          <Column>
            <Heading>
              <h4>關於我們</h4>
            </Heading>
            <nav>
              <ul>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/services/Default.aspx">服務介紹</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/about/Default.aspx">研究團隊</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/about/Copyright.aspx">版權聲明</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/member/QA.aspx">常見問題</a></li>
                <li><i className="fa fa fa-sitemap" /><a href="https://ieknet.iek.org.tw/sitemap/Default.aspx">網站導覽</a></li>
                <li><i className="fa fa-envelope" /><a href="https://ieknet.iek.org.tw/member/QA.aspx">客服專區</a></li>
              </ul>
            </nav>
          </Column>
          <Column>
            <Heading>
              <h4>研究領域</h4>
            </Heading>
            <nav>
              <GridList>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=1&amp;domain=2">半導體</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=3&amp;domain=43">資通訊</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=16&amp;domain=11">電子零組件</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=17&amp;domain=67">跨域科技</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=12&amp;domain=10">電子材料</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=5&amp;domain=28">綠能與環境</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=7&amp;domain=70">石化材料</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=6&amp;domain=73">生技醫療</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=15&amp;domain=52">機械</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=8&amp;domain=54">車輛</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&amp;indu_idno=11&amp;domain=86">國際產經</a></li>
              </GridList>
            </nav>
          </Column>
          <Column>
            <Heading>
              <h4>主題專區</h4>
            </Heading>
            <nav>
              <ul>
                <IEKTopicTitle onClick={handleClickIEKTopics}>
                  <i className="fa fa-angle-right" />
                  <span aria-haspopup="true" aria-expanded="false">
                    IEKTopics
                    <AngleDown className="fa fa-angle-down" />
                  </span>
                  <IEKTopicsOptions show={isShowIEKTopicsOptions}>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2021/" target="_blank" rel="noreferrer">2021 | 鏈國際：強韌協創 永續共榮</a>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2020_en/" target="_blank" rel="noreferrer">2020｜Resilient Ecosystem:Cross-domain Value Creation and Talent for Pilot</a>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2020collection/" target="_blank" rel="noreferrer">2020｜紀念合輯：揚帆2020 領航2030</a>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2020/" target="_blank" rel="noreferrer">2020｜韌生態：跨域創價 人才領航</a>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2019/" target="_blank" rel="noreferrer">2019｜創生態：科技加值 服務匯流</a>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2018/" target="_blank" rel="noreferrer">2018｜探新機：科技亞洲 產業創新</a>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2017/index.html" target="_blank" rel="noreferrer">2017｜建永續：循環再生 創新經濟</a>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2016/index.html" target="_blank" rel="noreferrer">2016｜解問題：智慧創新 樂活城市</a>
                    <a href="https://ieknet.iek.org.tw/IEKTopics/2015/index.html" target="_blank" rel="noreferrer">2015｜搶先機：物串心聯 網力全開</a>
                    <a href="https://ieknet.iek.org.tw/event/14event/14_0925/book/book.htm" target="_blank" rel="noreferrer">2014｜嬴未來：形塑生活 引領創新</a>
                    <a href="https://ieknet.iek.org.tw/event/13event/13_0801/book/13_0801.htm" target="_blank" rel="noreferrer">2013｜逆轉勝：台灣先進製造的新動力</a>
                  </IEKTopicsOptions>
                </IEKTopicTitle>
                <li><i className="fa fa-angle-right" /><a href="https://iektrends.iek.org.tw" target="_blank" rel="noreferrer">IEKTrends</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://www.youtube.com/user/ITRIIEK/feed" target="_blank" rel="noreferrer">IEKTalks</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://iekweb2.iek.org.tw/itisext/iekview/columnFrame.aspx" target="_blank" rel="noreferrer">IEKView</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/IEKInsight/index.html" target="_blank" rel="noreferrer">IEKInsight</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/event/epaper/IEKMonthly/MonthlyIndex.aspx" target="_blank" rel="noreferrer">IEKMonthly</a></li>
              </ul>
            </nav>
          </Column>
          <Column>
            <Heading>
              <h4>免費服務</h4>
            </Heading>
            <nav>
              <ul>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/iekrpt/DefaultFree.aspx">I卡會員專區</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/member/DailyNews.aspx">IEK每日產業情報</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/event/21event/iek_line/index.html">IEK產業情報網LINE@</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw/app/Default.aspx">APP服務</a></li>
              </ul>
            </nav>
          </Column>
          <Column>
            <Heading>
              <h4>全球網站</h4>
            </Heading>
            <nav>
              <ul>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet.iek.org.tw">Taiwan</a></li>
                <li><i className="fa fa-angle-right" /><a href="https://ieknet-eng.iek.org.tw">English</a></li>
                <li><i className="fa fa-angle-right" /><a href="http://ieknet.iek.org.tw/event/I-Global/iek_jp.html">Japan</a></li>
              </ul>
            </nav>
          </Column>
        </Row>
      </Container>
      <Copyright />
    </Root>
  )
}

const Root = styled.footer`
  width: 100%;
  background-image: url(${require('assets/images/footer/background.jpeg')});
  background-size: cover;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    pointer-events: none;
  }
`;

const Container = styled.div`
  position: relative;

  ${vw('padding-top', 40, 60)}
  ${vw('padding-bottom', 40, 100, 60)}
  ${vw('padding-left', 20, 80, 150)}
  ${vw('padding-right', 20, 80, 150)}
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: auto;
  justify-content: space-between;

  ${vw('grid-row-gap', 20, 30, 0)}

  @media ${media.tablet} {
    display: grid;
    justify-content: space-between;
    grid-template-columns: auto auto auto;
  }

  @media ${media.desktop} {
    display: flex;
    justify-content: space-between;
  }
`;

const Column = styled.div`
  @media ${media.tablet} {
    &:nth-of-type(2) {
      grid-column: 2 / 4;
    }
  }

  a, span {
    color: rgba(255, 255, 255, 0.8);
    font-weight: 400;
    text-decoration: none;

    ${vw('font-size', 12, 17)}
    ${vw('line-height', 12, 25)}
  }

  li {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    ${vw('padding-top', 6, 8)}
    ${vw('padding-bottom', 6, 8)}
  }

  i {
    color: rgba(255, 255, 255, 0.8);

    ${vw('margin-right', 6)}
    ${vw('padding-top', 2, 8)}
    ${vw('padding-bottom', 2, 8)}
  }
`;

const Heading = styled.div`
  ${vw('margin-bottom', 10, 20)}

  > h4 {
    width: fit-content;
    color: white;
    border-bottom: 1px solid rgba(255, 255, 255, 0.8);

    ${vw('padding-bottom', 10, 20)}
  }
`;

const GridList = styled.ul`
  display: grid;
  grid-template-columns: auto auto;

  ${vw('grid-column-gap', 20, 30)}
`;

const AngleDown = styled.i`
  height: auto;

  ${vw('font-size', 12)}
  ${vw('margin-left', 5)}
`;

const IEKTopicTitle = styled.li`
  cursor: pointer;
`;

const IEKTopicsOptions = styled.div`
  opacity: ${props => props.show ? '1' : '0'};
  pointer-events: ${props => props.show ? 'auto' : 'none'};
  transition: all 0.25s;
  position: absolute;
  background: white;

  > a {
    display: block;
    color: black;
    transition: all 0.25s;

    ${vw('padding-top', 2.5)}
    ${vw('padding-bottom', 2.5)}
    ${vw('padding-left', 10)}
    ${vw('padding-right', 10)}

    &:hover {
      background: lightgrey;
    }
  }
  
`;

export default Footer
